// extracted by mini-css-extract-plugin
module.exports = {"wrapperpp":"stylepp_wrapperpp__Y-ayX"};